import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import checkoutServices, {
  Referral,
} from "lib/features/checkout/checkoutService";

interface CheckoutSessionParams {
  id: string | undefined;
  startTime?: string;
  endTime?: string;
}

const getCheckoutSessionFn = async ({
  id,
  startTime,
  endTime,
}: CheckoutSessionParams) => {
  // should not happen because of enabled flag in useQuery
  if (!id) throw new Error("No checkout session ID provided");

  const response = await checkoutServices.getCheckoutSession(
    id,
    startTime,
    endTime,
  );
  const referral: Referral = response.data;

  const actualAvailabilities = referral.item.availabilities.filter(
    (av) =>
      av.record_status === true &&
      (av.private === false || av.id === referral.availability.id),
  );
  referral.item.availabilities = actualAvailabilities;

  return referral;
};

function useGetCheckoutSession({
  id,
  startTime,
  endTime,
}: CheckoutSessionParams) {
  return useQuery({
    queryKey: ["checkout-session", id, startTime, endTime],
    queryFn: () => getCheckoutSessionFn({ id, startTime, endTime }),
    enabled: !!id,
    placeholderData: (previousData) => previousData,
  });
}

export default useGetCheckoutSession;
